// extracted by mini-css-extract-plugin
export const hero = "hero-module--hero--25w3J";
export const dripTop = "hero-module--drip--top--18Umb";
export const dripBottom = "hero-module--drip--bottom--2Y4cQ";
export const portrait = "hero-module--portrait--2JAB-";
export const h1Title = "hero-module--h1--title--3AxG4";
export const background = "hero-module--background--2qGXJ";